import {configureStore} from '@reduxjs/toolkit';

import configReducer from './configSlice';
import loginReducer from '../login/loginSlice';
import langReducer from '../lang/langSlice';
import tokenReducer from '../tokenHandling/tokenSlice';
import appReducer from '../../features/app/appSlice';
import sidebarReducer from '../../features/app/context/device-sidebar/sidebarSlice';
import headerReducer from '../../features/app/header/headerSlice';
import {deviceStateMBBApi, deviceStateMBBRegistryApi, deviceStateTBM3Api} from '../../services/deviceStateApi';
import {journalNasysStateApi} from '../../services/journalNasysStateApi';
import {journalStoneridgeStateApi} from '../../services/journalStoneridgeStateApi';
import {journalContinentalStateApi} from '../../services/journalContinentalStateApi';
import {serviceCertificatesStateApi} from '../../services/serviceCertificatesStateApi';
import {
    nasysResultStateApi,
    quarterlyCM4DeviceRegistrationStateApi,
    quarterlyDeviceRegistrationStateApi,
} from '../../services/overviewStateApi';
import {
    deviceCertificateCM4Api,
    deviceCertificateTBMApi,
    deviceSigningInitMonitorStateApi,
    deviceSigningNotificationStateApi,
    deviceSigningStateApi,
    deviceSigningStateCM4Api
} from '../../services/deviceSigningStateApi';
import signingReducer from '../../features/app/context/device-signing/signingSlice';
import { logDeviceWhitelistCm4Api } from '../../services/logDeviceWhitelistCm4Tbm3Api';
import { logDeviceWhitelistOcu3Api } from '../../services/logDeviceWhitelistOcu3Api';
import { connectivityInterruptionApi } from '../../services/connectivityInterruptionApi';
import { devDeviceWhitelistApi } from '../../services/devDeviceWhitelistApi';
import { connectedVehiclesApi } from '../../services/connectedVehiclesApi';


export const store = configureStore({
    reducer: {
        config: configReducer,
        lang: langReducer,
        app: appReducer,
        sidebar: sidebarReducer,
        signing: signingReducer,
        login: loginReducer,
        tokenHandling: tokenReducer,
        appHeader: headerReducer,
        // Add the generated reducer as a specific top-level slice
        [deviceStateTBM3Api.reducerPath]: deviceStateTBM3Api.reducer,
        [deviceStateMBBApi.reducerPath]: deviceStateMBBApi.reducer,
        [deviceStateMBBRegistryApi.reducerPath]: deviceStateMBBRegistryApi.reducer,
        [journalNasysStateApi.reducerPath]: journalNasysStateApi.reducer,
        [journalStoneridgeStateApi.reducerPath]: journalStoneridgeStateApi.reducer,
        [journalContinentalStateApi.reducerPath]: journalContinentalStateApi.reducer,
        [serviceCertificatesStateApi.reducerPath]: serviceCertificatesStateApi.reducer,
        [deviceSigningStateApi.reducerPath]: deviceSigningStateApi.reducer,
        [deviceSigningInitMonitorStateApi.reducerPath]: deviceSigningInitMonitorStateApi.reducer,
        [deviceSigningNotificationStateApi.reducerPath]: deviceSigningNotificationStateApi.reducer,
        [nasysResultStateApi.reducerPath]: nasysResultStateApi.reducer,
        [quarterlyDeviceRegistrationStateApi.reducerPath]: quarterlyDeviceRegistrationStateApi.reducer,
        [quarterlyCM4DeviceRegistrationStateApi.reducerPath]: quarterlyCM4DeviceRegistrationStateApi.reducer,
        [deviceCertificateCM4Api.reducerPath]: deviceCertificateCM4Api.reducer,
        [deviceCertificateTBMApi.reducerPath]: deviceCertificateTBMApi.reducer,
        [deviceSigningStateCM4Api.reducerPath] : deviceSigningStateCM4Api.reducer,
        [logDeviceWhitelistCm4Api.reducerPath]: logDeviceWhitelistCm4Api.reducer,
        [logDeviceWhitelistOcu3Api.reducerPath]: logDeviceWhitelistOcu3Api.reducer,
        [connectivityInterruptionApi.reducerPath]: connectivityInterruptionApi.reducer,
        [devDeviceWhitelistApi.reducerPath]: devDeviceWhitelistApi.reducer,
        [connectedVehiclesApi.reducerPath]: connectedVehiclesApi.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([
        deviceStateTBM3Api.middleware,
        deviceStateMBBApi.middleware,
        deviceStateMBBRegistryApi.middleware,
        journalNasysStateApi.middleware,
        journalStoneridgeStateApi.middleware,
        journalContinentalStateApi.middleware,
        serviceCertificatesStateApi.middleware,
        deviceSigningStateApi.middleware,
        deviceSigningInitMonitorStateApi.middleware,
        deviceSigningNotificationStateApi.middleware,
        nasysResultStateApi.middleware,
        quarterlyDeviceRegistrationStateApi.middleware,
        quarterlyCM4DeviceRegistrationStateApi.middleware,
        deviceCertificateCM4Api.middleware,
        deviceCertificateTBMApi.middleware,
        deviceSigningStateCM4Api.middleware,
        logDeviceWhitelistCm4Api.middleware,
        logDeviceWhitelistOcu3Api.middleware,
        connectivityInterruptionApi.middleware,
        devDeviceWhitelistApi.middleware,
        connectedVehiclesApi.middleware,
    ]),
});

// Infer the `RootState` and `RootDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type RootDispatch = typeof store.dispatch;
